"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _selectV2Theme = require("../selectV2Theme");
const Actions = (0, _styled.default)("div")`
    display: inline-flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _selectV2Theme.selectV2Theme.actionButtons.gap(themeMode);
}};

    // For use in the SelectBasic component, we'll set this property.
    align-self: start;

    > button:last-child {
        margin-left: -1px;
    }

    ${_ref2 => {
  let {
    isReadonly,
    themeMode
  } = _ref2;
  return isReadonly ? `` : `
                margin-top: var(--smar--sds--actions--margin-top, ${_selectV2Theme.selectV2Theme.actionButtons.margin.top(themeMode)});
                margin-right: var(--smar--sds--actions--margin-right, ${_selectV2Theme.selectV2Theme.actionButtons.margin.right(themeMode)});
                margin-bottom: auto;
                margin-left: 0;
            `;
}}
`;
exports.Actions = Actions;
//# sourceMappingURL=Actions.js.map